import { Row } from 'antd';
import styled from 'styled-components';

export const ButtonStyled: React.CSSProperties = {
  minHeight: '2.5rem',
  alignItems: 'center',
  display: 'flex',
  marginBottom: '14px'
};

export const SectionHeader = styled.h5<{ $border?: boolean; $inTile?: boolean }>`
  padding: ${({ $inTile }) => ($inTile ? '0 0 30px' : '30px 0 30px 20px')};
  font-size: 1rem;
  font-weight: 600;
  border-top: ${({ $border, theme }) => ($border ? `7px solid ${theme.black.a1}` : 0)};
  margin: 0;
  &::first-letter {
    text-transform: capitalize;
  }
`;

export const SectionBody = styled.section<{ $tileSidePadding?: string; $tilesBottomPadding?: string }>(
  ({ theme, $tileSidePadding = '20px', $tilesBottomPadding = '20px' }) => `
  max-width: 100%;
  padding: 0 ${$tileSidePadding} ${$tilesBottomPadding};
  border-bottom: 1px solid ${theme.black.a1};
  &:last-child {
    border-bottom: none;
  }
`,
);

export const SubSection = styled(Row).attrs({ gutter: 10 })`
  align-items: center;
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-width: 67.5%;
`

export const RightSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const FormErrors = styled.section`
  padding: 20px 30px;
  color: ${({ theme }) => theme.red.a10};
  font-style: italic;
`;

export const Footer = styled.div`
  align-items: flex-end;
  padding: 20px 30px;
`;

export const ActionRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonSection = styled.div<{ $alignment?: 'left' | 'right' }>`
  display: flex;
  flex-direction: row;
  gap: 10px;
  ${({ $alignment }) => ($alignment === 'left' ? 'margin-right: auto' : 'margin-left: auto')};
`;

export const TextCol = styled.div<{ $tileSidePadding?: string; $tilesBottomPadding?: string }>(
  ({ theme, $tileSidePadding = '0px', $tilesBottomPadding = '0px' }) => `
  color: ${theme.baseBlue.a6};
  font-size: ${theme.sz.textFontSize};
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 ${$tileSidePadding} ${$tilesBottomPadding};
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: ${theme.sz.textLineHeight};
  max-height: 6.8em;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  min-height: 2.5rem;
  align-items: center;
  display: flex;
`,
);

export const DoubleDates = styled.div`
  display: flex;
  justify-content: space-between;
  div {
    &:nth-child(2) {
      margin-left: 15px;
    }
  }
`;

export const SectionKeyFeature = styled.div`
  display: flex;
  align-items: center;
`;

export const ErrorBox = styled.div`
  color: ${({ theme }) => theme.red.a10};
  font-style: italic;
  font-weight: 300;
  font-size: 0.8rem;
  margin-top: 1rem;
  text-transform: uppercase;
`;

export const LinkSectionStyled = styled.div<{ $hidden: boolean }>`
  margin: 0px 20px;
  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
  max-height: ${({ $hidden }) => ($hidden ? '0' : '1000px')};
  overflow: hidden;
  transform: ${({ $hidden }) => ($hidden ? 'scaleY(0)' : 'scaleY(1)')};
  transform-origin: top;
  transition: opacity 0.5s ease, max-height 0.5s ease, transform 0.5s ease;
`;

export const QRCodeContainerStyled = styled.div<{ $hidden: boolean }>`
  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
  max-height: ${({ $hidden }) => ($hidden ? '0' : '1000px')};
  overflow: hidden;
  transform: ${({ $hidden }) => ($hidden ? 'scaleY(0)' : 'scaleY(1)')};
  transform-origin: top;
  transition: opacity 0.5s ease, max-height 0.5s ease, transform 0.5s ease;
`;
